import { useFlightContext } from "hooks/flight/useFlightContext";
import React, { useEffect, useState } from "react";
import {
    Modal,
    ModalBody,
    ModalHeader,
    Nav,
    NavItem,
    TabContainer,
    TabContent,
    TabPane,
    NavLink,
    Card,
    CardHeader,
    CardBody,
} from "react-bootstrap";
import { useTranslation } from "react-i18next";
// import {  FaPlane } from "react-icons/fa6";
import { MdAirlineSeatReclineNormal, MdOutlineNumbers } from "react-icons/md";
import { BiSolidPlaneAlt } from "react-icons/bi";
import { PiSeatbelt } from "react-icons/pi";
import { formatTime } from "helpers/common";
import useApiClient from "hooks/useApiClient";
import { FaArrowRightLong } from "react-icons/fa6";
import { BsBagCheck, BsBagX } from "react-icons/bs";
import { createFareRulesPayload } from "helpers/flightHelper";
import { square } from 'ldrs'
square.register()

const FlightDetailModal = ({ isOpen, toggle, flight }) => {
    const { t } = useTranslation();
    const { flightSearchParams } = useFlightContext();

    return (
        <Modal show={isOpen} onHide={toggle} size="xl" className="w-[99%]" aria-hidden="true">
            <ModalHeader className="d-flex justify-content-between w-full">
                <div className="flex items-center gap-2 text-default text-lg fw-bold">
                    {t("flightDetails")}
                    {flightSearchParams?.openReturn && (
                        <span className="text-xs font-semibold px-2 py-0.5 rounded-full bg-green-100 text-green-700 border border-green-300">
                            {t("openReturn")}
                        </span>
                    )}
                </div>
                <button
                    type="button"
                    className="btn-close m-0"
                    onClick={toggle}
                />
            </ModalHeader>
            <ModalBody className="p-3">
                <TabContainer defaultActiveKey="1">
                    <Nav
                        variant="tabs"
                        className="border-none bg-hover-color rounded-md py-1  flex flex-nowrap px-2 mx-auto overflow-x-auto"
                    >
                        <NavItem className="flex-1 ">
                            <NavLink
                                className="text-center bg-transparent cursor-pointer my-1 truncate"
                                eventKey="1"
                            >
                                {t("flightInformation")}
                            </NavLink>
                        </NavItem>
                        <NavItem className="flex-1 ">
                            <NavLink
                                className="text-center bg-transparent  cursor-pointer my-1 truncate"
                                eventKey="3"
                            >
                                {t("baggageRules")}
                            </NavLink>
                        </NavItem>
                        <NavItem className="flex-1 ">
                            <NavLink
                                className="text-center bg-transparent  cursor-pointer my-1 truncate"
                                eventKey="4"
                            >
                                {t("cancellationRules")}
                            </NavLink>
                        </NavItem>
                    </Nav>
                    <TabContent className="mt-3">
                        <TabPane eventKey="1">
                            <FlightDetailsTab flight={flight} />
                        </TabPane>
                        <TabPane eventKey="3">
                            <BaggageRules flight={flight} />
                        </TabPane>
                        <TabPane eventKey="4">
                            <FareDetail flight={flight} />
                        </TabPane>
                    </TabContent>
                </TabContainer>
            </ModalBody>
        </Modal>
    );
};

export default FlightDetailModal;

const FlightDetailsTab = ({ flight }) => {
    const { t } = useTranslation();
    const { flightSearchParams } = useFlightContext();
    return (
        <div className="">
            {flight?.bounds.map((bound, index) => {
                if (flightSearchParams?.openReturn && index === 1) {
                    return (
                        <div key={index} className="rounded-md border mb-3 border-green-300 bg-green-50 p-4 flex items-center justify-center">
                            <span className="text-green-700 font-semibold text-sm">
                                {t("openReturn")}
                            </span>
                        </div>
                    );
                }
                return (
                    <Bound
                        bound={bound}
                        fareDetails={flight.recommendation.fareDetails[index][0]}
                        key={index}
                    />
                );
            })}
        </div>
    );
};

const Bound = ({ bound, fareDetails }) => {
    const { t } = useTranslation();
    const { availabilityResults } = useFlightContext();
    const { urls } = useApiClient();
    const { airportDictionary: airports } = availabilityResults || {};

    return (
        <div className="rounded-md border mb-3 border-border-color  p-2">
            {bound?.segments.map((segment, index) => (
                <div className="">
                    <div className="flex flex-col gap-2 md:gap-0 md:flex-row justify-between items-center">
                        <div className="flex flex-col justify-center items-center flex-1">
                            <div className="text-xl font-extrabold">
                                {segment?.departure?.locationId}
                            </div>
                            <div className="mb-0 text-default fw-bold">
                                {" "}
                                {segment?.departure?.full_date} {t(`at`)}{" "}
                                {segment?.departure?.time}{" "}
                            </div>
                            <p className="mb-0 text-center">
                                {airports &&
                                    airports[
                                        segment?.departure?.locationId
                                    ]?.display
                                        ?.replace("Aéroport", "")
                                        .replace("international", "")
                                        .replace("Airport", "")
                                        .replace(
                                            `(${segment?.departure?.locationId})`,
                                            ""
                                        )}
                            </p>
                        </div>
                        <div className=" flex flex-col items-center justify-center rotate-90 md:rotate-0 mx-4">
                            <img
                                src={`${process.env.REACT_APP_STATIC_URL}/${urls.flight.airlines}/${segment?.operatingCarrier}.png`}
                                alt="airline"
                                className="w-10 h-10"
                            />
                        </div>
                        <div className="flex flex-col justify-center items-center flex-1">
                            <div className="text-xl font-extrabold">
                                {segment?.arrival?.locationId}
                            </div>
                            <div className="mb-0 text-default fw-bold">
                                {" "}
                                {segment?.arrival?.full_date} {t(`at`)}{" "}
                                {segment?.arrival?.time}{" "}
                            </div>
                            <p className="mb-0 text-center">
                                {airports &&
                                    airports[
                                        segment?.arrival?.locationId
                                    ]?.display
                                        ?.replace("Aéroport", "")
                                        .replace("international", "")
                                        .replace("Airport", "")
                                        .replace(
                                            `(${segment?.departure?.locationId})`,
                                            ""
                                        )}
                            </p>
                        </div>
                    </div>
                    <div className="flex flex-wrap gap-2 justify-around mt-4">
                        <div className=" d-flex flex-row gap-2  align-items-center w-fit">
                            <MdOutlineNumbers className="text-subheader" />
                            <div className="text-subheader">
                                {t("flightNumber")} :{" "}
                            </div>
                            <div className=" ">
                                {" "}
                                {segment?.flightOrtrainNumber}{" "}
                            </div>
                        </div>
                        <div className=" d-flex flex-row gap-2  align-items-center w-fit">
                            <BiSolidPlaneAlt className="text-subheader" />
                            <div className="text-subheader">
                                {t("plane")} :{" "}
                            </div>
                            <div className=" "> {segment?.equipmentType} </div>
                        </div>
                        <div className=" d-flex flex-row gap-2  align-items-center w-fit">
                            <MdAirlineSeatReclineNormal className="text-subheader" />
                            <div className="text-subheader">
                                {t("cabin")} :{" "}
                            </div>
                            <div className=" "> {fareDetails?.cabin} </div>
                        </div>
                        <div className=" d-flex flex-row gap-2  align-items-center w-fit">
                            <PiSeatbelt className="text-subheader" />
                            <div className="text-subheader">
                                {t("availableSeat")} :{" "}
                            </div>
                            <div className=" ">
                                {fareDetails?.availableStatus}
                            </div>
                        </div>
                    </div>
                    {index !== bound.nbStops && (
                        <div className="bg-light text-center fw-normal rounded-2 mt-3 mb-4 p-2">
                            {t("waitingTimeIs")} :{" "}
                            {formatTime(bound?.stopDuration)
                                .replace("hours", t("hours"))
                                .replace("hour", t("hours"))
                                .replace("mins", t("mins"))}{" "}
                        </div>
                    )}
                </div>
            ))}
        </div>
    );
};

const BaggageRules = ({ flight }) => {
    const baggage = flight.baggagePerBound;
    const { t } = useTranslation();
    const { urls } = useApiClient();
    const { flightSearchParams } = useFlightContext();
    if (!baggage) {
        return <div> no baggage rule</div>;
    }
    const departure = flight?.bounds[0]?.departure?.locationId;
    const arrival = flight?.bounds[0]?.arrival?.locationId;
    return (
        <div className="d-flex flex-column ">
            {baggage.map((bagRule, indx) => {
                const isOpenReturnBound = flightSearchParams?.openReturn && indx === 1;
                const returnDate = flight?.bounds[1]?.segments?.[0]?.departure?.full_date;
                return (
                    <Card className="border bg-light mb-3">
                        <CardHeader className="d-flex flex-row font-weight-bold justify-content-start  align-items-center border-bottom">
                            {isOpenReturnBound ? (
                                <span className="text-xs font-semibold px-2 py-1 rounded-full bg-green-100 text-green-700 border border-green-300 whitespace-nowrap">
                                    {t("openReturn")}{returnDate ? ` - ${returnDate}` : ""}
                                </span>
                            ) : (
                                <img
                                    src={`${process.env.REACT_APP_STATIC_URL}/${urls.flight.airlines}/${flight?.bounds[indx]?.airlines[0]}.png`}
                                    alt="airline"
                                    className="size-8"
                                />
                            )}
                            <div className="text-header mx-3 ">
                                {indx === 0 ? departure : arrival}
                            </div>
                            <FaArrowRightLong />
                            <div className="text-header mx-3">
                                {indx === 0 ? arrival : departure}
                            </div>
                        </CardHeader>
                        <CardBody>
                            {bagRule.withBaggage ? (
                                <>
                                    {bagRule.quantityCode === "W" ? (
                                        <div className="text-subheader d-flex align-items-center">
                                            <BsBagCheck
                                                className=""
                                                style={{ fontSize: "25px" }}
                                            />
                                            &nbsp; {bagRule.freeAllowance}{" "}
                                            &nbsp; {t("KG")}{" "}
                                            {!flight.isZoneb && (
                                                <>
                                                    <BsBagCheck
                                                        className=""
                                                        style={{
                                                            fontSize: "20px",
                                                        }}
                                                    />
                                                    {t("cabinBaggage")}
                                                </>
                                            )}
                                        </div>
                                    ) : (
                                        <>
                                            {bagRule.quantityCode === "P" ||
                                                (bagRule.quantityCode ===
                                                    "N" && (
                                                    <div className="text-subheader d-flex align-items-center">
                                                        <BsBagCheck
                                                            className=""
                                                            style={{
                                                                fontSize:
                                                                    "25px",
                                                            }}
                                                        />
                                                        &nbsp; &nbsp;{" "}
                                                        {t("nmbPiece")} :{" "}
                                                        {bagRule.freeAllowance}{" "}
                                                        &nbsp;
                                                        {!flight.isZoneb && (
                                                            <>
                                                                <BsBagCheck
                                                                    className=""
                                                                    style={{
                                                                        fontSize:
                                                                            "20px",
                                                                    }}
                                                                />
                                                                &nbsp;{" "}
                                                                {t(
                                                                    "cabinBaggage"
                                                                )}
                                                            </>
                                                        )}
                                                    </div>
                                                ))}
                                        </>
                                    )}
                                </>
                            ) : (
                                <div className="text-subheader d-flex align-items-center  ">
                                    <BsBagX
                                        className="text-danger"
                                        style={{ fontSize: "25px" }}
                                    />
                                    &nbsp; &nbsp;{t("noBaggage")} &nbsp;
                                    {!flight.isZoneb && (
                                        <>
                                            <BsBagCheck
                                                className=""
                                                style={{ fontSize: "20px" }}
                                            />
                                            &nbsp; {t("onlyCabinBaggage")}
                                        </>
                                    )}
                                </div>
                            )}
                        </CardBody>
                    </Card>
                );
            })}
        </div>
    );
};

const FareDetail = ({ flight }) => {
    const { api, urls } = useApiClient();
    const [fareRules, setFareRules] = useState(null);
    const [loading, setLoading] = useState(false);
    const { i18n, t } = useTranslation();
    const { flightSearchParams } = useFlightContext();

    useEffect(() => {
        if (flight) {
            setLoading(true);
            const payload = createFareRulesPayload(flight);
            payload["language"] = i18n.language;
            payload["openReturn"] = flightSearchParams?.openReturn ? "true" : "false";
            api.post(urls.flight.fareRules, JSON.stringify(payload))
                .then((res) => {
                    setFareRules(res.data.result.fare);
                })
                .catch((err) => {
                    console.error("Error fetching fare rules:", err);
                })
                .finally(() => {
                    setLoading(false);
                });
        }
    }, [api, flight, flightSearchParams?.openReturn, i18n.language, urls.flight.fareRules]);
    if (loading) {
        return (
            <div
                className="w-100   d-flex  justify-content-center align-items-center"
                style={{ height: "120px" }}
            >
                <l-square
                    size="40"
                    stroke="3.5"
                    speed="1"
                    color="black"
                ></l-square>
            </div>
        );
    }
    if (fareRules === null || fareRules[0].length === 0) {
        return <div className="">no fare rules found</div>;
    }

    return (
        <div className="d-flex flex-column ">
            <Card className="border  bg-light">
                <CardHeader className="d-flex flex-row font-weight-bold justify-content-start  align-items-center border-bottom">
                    <img
                        src={`${process.env.REACT_APP_STATIC_URL}/${urls.flight.airlines}/${flight?.bounds[0].airlines[0]}.png`}
                        alt=""
                        className="size-16"
                    />
                    <div className="text-header mx-3 ">{`${flight?.bounds[0]?.departure?.locationId}`}</div>
                    <FaArrowRightLong />
                    <div className="text-header mx-3">{`${flight?.bounds[0]?.arrival?.locationId}`}</div>
                </CardHeader>
                <CardBody>
                    {fareRules[0]["Flight_Conditions"].map((rule, idx) => {
                        return (
                            <div
                                key={idx}
                                className="d-flex flex-row justify-content-between"
                            >
                                <div>{rule}</div>
                            </div>
                        );
                    })}
                </CardBody>
            </Card>
            <div className="my-2"></div>
            {fareRules && fareRules[1].length !== 0 && (
                <Card className="border bg-light ">
                    <CardHeader className="d-flex flex-row font-weight-bold justify-content-start  align-items-center border-bottom">
                        {flightSearchParams?.openReturn ? (
                            <span className="text-xs font-semibold px-2 py-1 rounded-full bg-green-100 text-green-700 border border-green-300 whitespace-nowrap">
                                {t("openReturn")}{flight?.bounds[1]?.segments?.[0]?.departure?.full_date ? ` - ${flight?.bounds[1]?.segments?.[0]?.departure?.full_date}` : ""}
                            </span>
                        ) : (
                            <img
                                src={`${process.env.REACT_APP_STATIC_URL}/${urls.flight.airlines}/${flight?.bounds[1]?.airlines[0]}.png`}
                                alt=""
                                className="size-16"
                            />
                        )}
                        <div className="text-header mx-3 ">{`${flight?.bounds[0]?.arrival?.locationId}`}</div>
                        <FaArrowRightLong />
                        <div className="text-header mx-3">{`${flight?.bounds[0]?.departure?.locationId}`}</div>
                    </CardHeader>
                    <CardBody>
                        {fareRules[1]["Flight_Conditions"].map((rule, idx) => {
                            return (
                                <div
                                    key={idx}
                                    className="d-flex flex-row justify-content-between"
                                >
                                    <div>{rule}</div>
                                </div>
                            );
                        })}
                    </CardBody>
                </Card>
            )}
        </div>
    );
};
